<template>
  <md-list>
    <md-list-item>
      <md-icon>euro_symbol</md-icon>
      <div class="md-list-item-text">
        <span>{{terms.price | formatMoney}}</span>
        <span v-if="terms.monthly">Monthly</span>
        <span v-else>Daily</span>
      </div>
    </md-list-item>
    <md-list-item class="md-inset" v-if="terms.deposit">
      <div class="md-list-item-text">
        <span>{{terms.deposit | formatMoney}}</span>
        <span>Deposit</span>
      </div>
    </md-list-item>

    <md-divider class="md-inset mb-3 mt-3"></md-divider>

    <md-list-item>
      <md-icon>repeat</md-icon>
      <div class="md-list-item-text">
        <span>{{terms.periodStart | formatDate}}</span>
        <span>Move in</span>
      </div>
    </md-list-item>
    <md-list-item class="md-inset" v-if="terms.periodEnd">
      <div class="md-list-item-text">
        <span>{{terms.periodEnd | formatDate}}</span>
        <span>Move out</span>
      </div>
    </md-list-item>
    <md-list-item v-if="terms.noticePeriod_months">
      <md-icon>warning</md-icon>
      <div class="md-list-item-text">
        <span>Notice given on {{terms.noticeGivenAt | formatDate}}</span>
        <span>Notice period {{terms.noticePeriod_months}} months</span>
      </div>
    </md-list-item>
  </md-list>
</template>
<script>
import { formatISOShortToDDMonthYYYY } from "@/timeFunctions";
import moment from "moment";
export default {
  props: {
    terms: {
      type: Object,
      required: true
    }
  },
  components: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  created() {},
  methods: {},
  filters: {
    formatMoney(value){
      try {
        return Number(value).toFixed(2);
      } catch (ex) {
        return value;
      }
    },
    formatDate(value) {
      if (!value) {
        return "";
      }
      return moment(value).format("DD MMM YYYY") || "";
    }
  }
};
</script>
<style scoped>
@import "../../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/bookings/deals/dealTermsList.vue